/**
 * What differs between plans, read off the same `limits` object the API
 * itself enforces - one list, shared by the landing page's pricing table and
 * the billing page's "compare plans" dialog, so a limit added to one can't
 * quietly go missing from the other.
 *
 * A row's `render` returns either a boolean (rendered as an included/not
 * included mark) or a string/number to print as-is - callers decide how a
 * boolean looks, since the landing page's dark-themed checkmark and the
 * billing page's light-themed one are different components.
 */

// Pro's ceilings are deliberately high rather than truly unlimited - these
// are the ones shown that way, with a footnote explaining why.
export const FAIR_USE_KEYS = ["maxProjects", "maxCustomTaskTypes", "maxCustomBugTypes"];
export const isFairUse = (plan, key) => plan.tier === "PRO" && FAIR_USE_KEYS.includes(key);

export const formatBytes = (bytes) => (bytes >= 1024 * 1024 ? `${Math.round(bytes / (1024 * 1024))} MB` : `${Math.round(bytes / 1024)} KB`);

export const COMPARISON_ROWS = [
    {label: "Projects", render: (l, plan) => (isFairUse(plan, "maxProjects") ? "Unlimited*" : l.maxProjects)},
    {label: "People per project", render: (l) => l.maxUsersPerProject},
    {label: "Custom task types", render: (l, plan) => (isFairUse(plan, "maxCustomTaskTypes") ? "Unlimited*" : l.maxCustomTaskTypes || "—")},
    {label: "Custom bug types", render: (l, plan) => (isFairUse(plan, "maxCustomBugTypes") ? "Unlimited*" : l.maxCustomBugTypes || "—")},
    {label: "Custom fields on tasks", render: (l) => Boolean(l.allowCustomTaskFields)},
    {label: "Custom fields on bugs", render: (l) => Boolean(l.allowCustomBugFields)},
    {label: "Editable Kanban columns", render: (l) => Boolean(l.allowKanbanColumnEdit)},
    {label: "Custom work week", render: (l) => Boolean(l.allowCustomWorkWeek)},
    {label: "Organization management", render: (l) => Boolean(l.allowOrganizations)},
    {label: "Anonymous bug reporting", render: (l) => Boolean(l.allowAnonymousBugEntry)},
    {label: "Support ticket management", render: (l) => Boolean(l.allowSupportTickets)},
    {label: "API access & integrations", render: (l) => Boolean(l.allowApiAccess)},
    {label: "Image upload limit", render: (l) => formatBytes(l.maxImageUploadBytes)},
    {label: "Image resolution", render: (l) => `${l.imageMaxWidth} × ${l.imageMaxHeight}`},
    {label: "Support", render: (l) => (l.supportLevel === "EXPEDITED" ? "Expedited" : "Standard")},
];
